import { noop } from "@pjs/utilities";
import { IEditor } from "../../editor/interfaces/IEditor";

export function autoEnable(editorController: IEditor): () => void {
    editorController.enable();
    return noop;
}
